<div class="sum-items-container">
    <!-- <span class="text">{{ 'aumico_notes_super_table_add_calculation_title_placeholder' | i18next }}</span>

    <input
        hamInput
        [formControl]="titleControl"
        [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
    /> -->

    <div class="column-selection-container">
        <input
            hamSimpleDropDown
            [options]="nameIdColSelections"
            [optionKeys]="['name']"
            [selectedOptions]="existingSelectedColumns"
            returnKey="id"
            readonly
            [returnObject]="true"
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [multiple]="true"
            (selectionChange)="onSelectItem($event)"
        />
        <span *ngIf="selectedItems.length === 0" class="label">{{
            'aumico_notes_super_table_select_summation_columns_label' | i18next
        }}</span>
    </div>

    <div class="column-selection-container">
        <span class="text">{{ 'aumico_notes_super_table_add_column_width' | i18next }}</span>
        <input
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [options]="columnWidthSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [multiple]="false"
            [formControl]="columnWidthControl"
        />
    </div>

    <div class="belonging-year-container">
        <span class="text">{{ 'aumico_notes_super_table_add_free_column_belonging_year' | i18next }}</span>
        <input
            hamSimpleDropDown
            [options]="belongingYearSelections"
            [optionKeys]="['name']"
            returnKey="id"
            [allowFreeText]="false"
            [placeholder]="'aumico_notes_super_table_add_free_column_belonging_year' | i18next"
            [multiple]="false"
            [formControl]="belongingYearControl"
        />
    </div>
</div>
